<template>
  <section class='faq' v-if="itemsComputed.length">
    <div class="default-content">

      <h2 class='section-title'>{{ locales && locales.pages && locales.pages.frequently_asked_questions }}</h2>
      <ul class='faq__list'>
        <li v-for='(item, index) in itemsComputed' :key='index' class='faq__list-item'>
          <div class='faq__list-opener' @click='toggleItem(index)'>
            {{ item.question }}
            <i v-if='!selected.includes(index)' class='icon-plus'/>
            <i v-else class='icon-minus'/>
          </div>
          <div v-if='selected.includes(index)' class='faq__list-content'>
            {{ item.answer }}
          </div>
        </li>
      </ul>
      <a href='#' class='theme-btn theme-btn--tertiary' @click.prevent='showMore = !showMore'>
        <template v-if='!showMore'>
          {{ locales && locales.common && locales.common.show_more }}
          <i class='icon-thin-down'/>
        </template>
        <template v-else>
          {{ locales && locales.common && locales.common.show_less }}
          <i class='icon-thin-up'/>
        </template>
      </a>

    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      items: {
        default: [],
        type: Array
      }
    },
    data() {
      return {
        showMore: false,
        selected: [],
      };
    },
    computed: {
      ...mapGetters(["locales"]),
      itemsComputed() {
        const localItems = JSON.parse(JSON.stringify(this.items));
        return this.showMore ? localItems : localItems.slice(0, 5);
      },
    },
    methods: {
      toggleItem(index) {
        const localSelected = JSON.parse(JSON.stringify(this.selected));
        if (localSelected.includes(index)) {
          this.selected = localSelected.filter(item => item !== index);
        } else {
          localSelected.push(index);
          this.selected = localSelected;
        }
      },
    },
  };
</script>
